<template>
  <b-card v-if="chartsLoaded" class="chartContainer">
    <b-row>
      <b-col>
        <apexchart type="bar" height="400" :options="barChartOptions" :series="reaisSeries"></apexchart>
      </b-col>
      <b-col>
        <apexchart type="radialBar" height="400" :options="radioChartOptions" :series="radioChartSeries"></apexchart>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import { SistemaMixin } from "@/modules/Application";
import { chartStore } from "@/components/Charts/chartStore";

export default {
  name: "chart-contas-receber",
  mixins: [SistemaMixin],
  data() {
    return {
      chartStore,
      chartsLoaded: false,
      radioChartValues: [],
      barChartOptions: {
        colors: ['#ffe380', '#13d8aa', '#d4526e'],
        chart: {
          id: 'contas-receber-chart',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 2,
            horizontal: true,
            distributed: true,
            barHeight: '50%',
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#fff']
          },
          formatter: function (val) {
            return val
          },
          offsetX: 0,
        },
        xaxis: {
          categories: []
          // categories: ['Contas a pagar', 'Contas pagas', 'Contas atrasadas']
        },
      },
      reaisSeries: [{
        data: [1, 2, 3]
      }],
      radioChartOptions: {
        chart: {
          height: 390,
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            // endAngle: 270,
            hollow: {
              margin: 5,
              size: '20%',
              background: 'transparent',
              image: undefined,
            },
          },
          legend: {
            show: false,
            floating: true,
            fontSize: '16px',
            position: 'left',
            offsetX: 160,
            offsetY: 15,
            labels: {
              useSeriesColors: true,
            },
            markers: {
              size: 0
            },
            itemMargin: {
              vertical: 3
            }
          },
        },

        colors: ['#33b2df', '#ffe433', '#13d8aa', '#d4526e'],
        labels: [],
        legend: {
          show: false,
          floating: true,
          fontSize: '14px',
          position: 'left',
          offsetX: 90,
          offsetY: 15,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 0
          },
          formatter: function (seriesName, opts) {
            return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex].value
          },
          itemMargin: {
            vertical: 3
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              show: false
            }
          }
        }]
      },
      totalContas: 0,
      radioChartSeries: []
    };
  },
  props: ['endpoint'],
  methods: {
    async loadContasReceberTotais(bodyToSendToApi) {
      try {
        const body = {
          columnFilters: {
            ...bodyToSendToApi
          }
        }
        const { data } = await this.$http.post(this.endpoint, body)
        const dataToArray = Object.entries(data).map(item => item[1])
        const length = dataToArray.length

        this.reaisSeries = [{
          name: 'Total',
          data: null
        }]
        this.reaisSeries[0].data = dataToArray.map(el => el.value_monetario)
        this.barChartOptions.dataLabels.formatter = (val) => {
          return this.numberToReal(val, 2)
        }
        this.barChartOptions.colors = length === 2 ?
          ['#13d8aa', '#d4526e'] :
          ['#ffe380', '#13d8aa', '#d4526e']

        this.radioChartOptions.colors = length === 2 ?
          ['#33b2df', '#13d8aa', '#d4526e'] :
          ['#33b2df', '#ffe433', '#13d8aa', '#d4526e']

        const totalContas = dataToArray.reduce((acc, el) => acc + el.value, 0)
        this.radioChartValues = dataToArray.map(el => el.value)
        this.radioChartSeries = [100, ...this.radioChartValues.map(item => Math.round(((item / totalContas) * 100) * 100) / 100)]
        this.radioChartOptions.labels = ['Total', ...dataToArray.map(item => item.label)]
        this.barChartOptions.xaxis.categories = dataToArray.map(item => item.label)
        this.radioChartOptions.legend.formatter = (seriesName, opts) => {
          return seriesName + ":  " + this.radioChartValues[opts.seriesIndex]
        }
        this.chartsLoaded = true;

      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked", "nutsDigital"]),
    config() {
      return this.layoutConfig();
    },
  },
  watch: {
    'chartStore.bodyToSendToApi'(newValue) {
      this.loadContasReceberTotais(newValue)
    }
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.loadContasReceberTotais()
  },
};
</script>

<style>
.chartContainer {
  display: flex;
}
</style>